/* eslint-disable max-lines-per-function */
import React, { memo } from 'react';
import { connect } from 'react-redux';
import { ChildIcon, AdultIcon, BabyIcon, EditIcon, DeleteIcon } from '~svg';
import { Tooltip } from '../../../common';
import momentjs from 'moment-jalaali';
import PropTypes from 'prop-types';
import '../../../specific/profile/employeeCard/employeeCard.scss';

const DATE_FORMAT_MOMENT_SHAMSI_JALALI = 'jYYYY-jMM-jDD';
const FriendCard = (props) => {
  const {
    item,
    customClass,
    indx,
    language: { direction, name },
  } = props;
  let fullName = `${item.firstName} ${item.lastName}`;

  return (
    <div
      className="col-xl-4 col-lg-6 col-sm-6 w-100 px-0 d-flex flex-row justify-content-center pb-4"
      key={indx}
    >
      <div
        key={`friend-${item.id}`}
        className={`p-2 col-11 bg-white shadow default-border-radius-small ${customClass}`}
      >
        <div className="d-flex justify-content-between m-1">
          <span
            className="cursor-pointer"
            onClick={() => {
              props?.onEdit(item);
            }}
          >
            <EditIcon size={16} color="#85cd95" />
          </span>
          <span
            className="cursor-pointer"
            onClick={() => {
              props?.onDelete(item);
            }}
          >
            <DeleteIcon size={16} color="#e21919 " />
          </span>
        </div>
        <div className="d-flex justify-content-center align-items-center py-3">
          <img
            style={{ width: '55px' }}
            className=""
            src={require(`../../../../content/images/avatars/${
              item?.avatar || '10.png'
            }`)}
            alt=""
          />
        </div>
        <div className="d-flex flex-column align-items-center font-small py-2 text-nowrap">
          <Tooltip
            position={'top'}
            content={fullName.slice(0, 85) || '---'}
            direction={direction}
            backgroundColor="warning"
            textColor="dark"
            customClassName={'w-100 text-wrap'}
          >
            <h5 className="pb-1 text-center m-0 px-2 text-nowrap text-truncate">
              {fullName || '---'}
            </h5>
          </Tooltip>
          <h6 className="text-muted pb-2 text-start font-small">
            <Tooltip
              position={'top'}
              content={item.nationalCode}
              direction={direction}
              backgroundColor="warning"
              textColor="dark"
            >
              <span>{item?.nationalCode || item?.passportNo}</span>
            </Tooltip>
          </h6>
          <div className="email-box  font-weight-bold d-flex align-items-center justify-content-start bg-third-light px-3 py-2 default-border-radius-small">
            <span className="d-flex align-items-center justify-content-center px-1">
              {item?.type.toLowerCase() === 'child' && (
                <ChildIcon color="#00798c" />
              )}
              {item?.type.toLowerCase() === 'adult' && (
                <AdultIcon color="#00798c" />
              )}
              {item?.type.toLowerCase() === 'infant' && (
                <BabyIcon color="#00798c" />
              )}
            </span>
            <span style={{ direction: 'ltr' }} className="px-1">
              {(direction === 'rtl' && name !== 'ar'
                ? momentjs(item.birthDate, 'YYYY-MM-DD').format(
                    DATE_FORMAT_MOMENT_SHAMSI_JALALI,
                  )
                : item.birthDate) ?? '---'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

FriendCard.propTypes = {
  item: PropTypes.object,
  customClass: PropTypes.string,
};

FriendCard.defaultProps = {
  item: {},
  customClass: '',
};

export default connect(mapStateToProps)(memo(FriendCard));
